const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  orderListItem: [],
};

const orderListSlice = createSlice({
  name: "orderList",
  initialState: initialState,
  reducers: {
    setOrderListItem(state, action) {
      state.orderListItem = action.payload;
    },
  },
});

export const { setOrderListItem } = orderListSlice.actions;

export default orderListSlice.reducer;
